
export default {
  name: 'CompletedPlug',
  data() {
    return {
      i18n: 'pages.education.courses-list'
    }
  }
}
